var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgSimplifySectionDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1439,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF0EC",
    fillRule: "evenodd",
    opacity: 0.071,
    transform: "translate(-171 -373)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 310.431,
    height: 708,
    x: 205,
    y: 410,
    rx: 155.215,
    transform: "scale(1 -1) rotate(-45 -1484.244 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 310.431,
    height: 708,
    x: 1269,
    y: 7,
    rx: 155.215,
    transform: "scale(1 -1) rotate(-45 552.684 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSimplifySectionDesktop);
export default __webpack_public_path__ + "static/media/bg-simplify-section-desktop.ca40c1eebd150b1cc7dc266ce0b13d87.svg";
export { ForwardRef as ReactComponent };